import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import combineStyles from '../../utils/combineStyles';
import { withStyles } from '@material-ui/core/styles';
import { withNamespaces } from 'react-i18next';
import TypographyStyles from '../../styles/typography';
import LayoutStyles from '../../styles/layout';
import SpacingStyles from '../../styles/helpers/spacing';
import LabelsStyles from './__styles__/Labels.styles';
import FormItemContainerStyles from '../../components/Global/Containers/__styles__/FormItemContainer.styles';
import { UNIT_ABBREVIATIONS } from '../../constants/constants';
import { formatDate } from '../../utils/DateTime';

class ShipmentInfo extends Component {
  state = {
    classText: ''
  };

  static propTypes = {
    shipment: PropTypes.object.isRequired,
    itemIndex: PropTypes.number.isRequired,
    unit: PropTypes.object.isRequired,
    totPackages: PropTypes.number.isRequired
  };

  render() {
    const { shipment, itemIndex, unit, totPackages, classes, t } = this.props;

    const classText = unit.freightInfo.freightClassName;
    const pickup = shipment.stops[0];

    return (
      <Grid item xs={3} className={classes.labelFont}>
        <div>
          <div className={classes.emphasizedText}>
            {unit.packageTypeId} {itemIndex + 1} of {totPackages}
          </div>
          <div className={classes.boldText}>
            {t('Planned Pickup')}: {formatDate(pickup.plannedFromTimeLocal)}
          </div>
          <div>
            {t('Shipment')} #: {shipment.id}
          </div>
          <div>
            {t('BOL')}#: {shipment.bolNumber}
          </div>
          <div>
            {t('Carrier Pickup')}#: {shipment.carrierPickupNumber}
          </div>
          <div>
            {t('Unit Weight')}: {unit.actualWeightInfo.weight}{' '}
            {UNIT_ABBREVIATIONS[unit.actualWeightInfo.weightUnit]}
          </div>
          <div>
            {t('Unit Class')}: {classText}
          </div>
        </div>
      </Grid>
    );
  }
}

const translatedShipmentInfo = withNamespaces()(ShipmentInfo);
export default withStyles(
  combineStyles(
    LabelsStyles,
    FormItemContainerStyles,
    TypographyStyles,
    LayoutStyles,
    SpacingStyles
  )
)(translatedShipmentInfo);
